/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneQueryResponse, DocumentsControllerFindOnePathParams, DocumentsControllerFindOneQueryParams, DocumentsControllerFindOne400, DocumentsControllerFindOne401, DocumentsControllerFindOne403, DocumentsControllerFindOne404 } from "../../models/documentsController/DocumentsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindOne } from "../../clients/documentsService/documentsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindOneQueryKey = (id: DocumentsControllerFindOnePathParams["id"], params: DocumentsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/documents/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerFindOneQueryKey = ReturnType<typeof documentsControllerFindOneQueryKey>;
export function documentsControllerFindOneQueryOptions(id: DocumentsControllerFindOnePathParams["id"], params?: DocumentsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindOneQueryKey(id, params);
  return queryOptions<DocumentsControllerFindOneQueryResponse, ResponseErrorConfig<DocumentsControllerFindOne400 | DocumentsControllerFindOne401 | DocumentsControllerFindOne403 | DocumentsControllerFindOne404>, DocumentsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a document by ID
 * {@link /api/v1/documents/:id}
 */
export function useDocumentsControllerFindOne<TData = DocumentsControllerFindOneQueryResponse, TQueryData = DocumentsControllerFindOneQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindOneQueryKey>(id: DocumentsControllerFindOnePathParams["id"], params?: DocumentsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindOneQueryResponse, ResponseErrorConfig<DocumentsControllerFindOne400 | DocumentsControllerFindOne401 | DocumentsControllerFindOne403 | DocumentsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...documentsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindOne400 | DocumentsControllerFindOne401 | DocumentsControllerFindOne403 | DocumentsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}